import axios from 'axios'
import { EventTypes } from 'redux-segment'

export function createManualInputRecord(companyParam,siteParam,manualInputParam,params) {
  return (dispatch, getState) => {
    dispatch({
      type: 'MANUAL_INPUT_RECORD_CREATE',
      payload: axios.post(`companies/${companyParam}/sites/${siteParam}/manual_inputs/${manualInputParam}/manual_input_records`,params)
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/ManualInputActions.js